module.exports = __webpack_public_path__ + "static/media/map-placeholder.0c6d0aa0.webp";